import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';

import { QueueAssignee } from '@totem/components/ticketing/queueManagement/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { formatDateOnly } from '@totem/utilities/common';

type Props = {
  assignees: QueueAssignee[];
  onRemove: (email: string) => void;
};

const QueueAssigneesTable = ({ assignees, onRemove }: Props) => {
  const activeAssignees = assignees.filter((assignee) => !assignee.endTime);

  const columns: ColumnProps<QueueAssignee>[] = [
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (rec, cmp) => rec.email.localeCompare(cmp.email),
    },
    {
      title: 'Start Date',
      dataIndex: 'startTime',
      key: 'startTime',
      render: (_, assignee: QueueAssignee) =>
        formatDateOnly(assignee.startTime),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 90,
      render: (_, assignee: QueueAssignee) => (
        <div className="center-table-cell">
          <Tooltip title="Remove Assignee">
            <Popconfirm
              title="Remove this assignee?"
              description={`Remove ${assignee.email} from this queue?`}
              okText="Remove"
              okType="danger"
              cancelText="Cancel"
              onConfirm={() => onRemove(assignee.email)}
            >
              <Button danger icon={<DeleteOutlined />} shape="circle" />
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <IBTable<QueueAssignee>
      showSorterTooltip
      columns={columns}
      dataSource={activeAssignees}
      rowKey={(record) => record.email}
      pagination={{
        defaultPageSize: 20,
        showSizeChanger: true,
      }}
    />
  );
};

export default QueueAssigneesTable;
